/**
 * クライアント側で一意な ID/キーを採番するユーティリティ。
 *
 * `crypto.randomUUID()` は**セキュアコンテキスト限定**の API で、http:// で配信される
 * dev 環境（ALB 直・ドメイン未整備）では未定義になり画面がクラッシュするため、
 * クライアント採番には使わない（2026-08-13 エビデンスマスタ編集画面で発症）。
 */

let seq = 0;

/**
 * React key など、セッション内で一意なら足りるクライアント専用キーを採番する。
 *
 * @param prefix - キーの接頭辞（例: "step"）。
 */
export function newLocalId(prefix = "uid"): string {
  seq += 1;
  return `${prefix}-${seq}-${randomHex(8)}`;
}

/**
 * 長さ `length` の16進乱数文字列を返す（`Math.random` ベース・非暗号用途）。
 *
 * マスタコードの自動採番など「衝突しにくければ良い」用途向け。
 *
 * @param length - 返す文字数。
 */
export function randomHex(length: number): string {
  let out = "";
  while (out.length < length) {
    out += Math.floor(Math.random() * 0xffffffff)
      .toString(16)
      .padStart(8, "0");
  }
  return out.slice(0, length);
}
